export default "/_next/static/images/fd118e2a225813d572327e3b05e52440.jpg";